import { render } from "./ResumeUpload.vue?vue&type=template&id=c3856c6e"
import script from "./ResumeUpload.vue?vue&type=script&lang=js"
export * from "./ResumeUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__